import { useEffect, useState } from 'react';
import { supabase } from './supabaseClient';
// Rimuovi l'importazione del CSS originale
// import './DashboardBroker.css';
import './tailwind.css';
import SidebarMenu from './SidebarBrokerMenu';
import TopBarMobile from './TopBarMobile'; // Presumo che TopBarMobile gestisca il bottone hamburger per mobile
import { Outlet, useNavigate } from 'react-router-dom';

export default function DashboardBroker() {
  const [userData, setUserData] = useState({ nome: '', cognome: '', ruolo: null });
  // Lo stato isSidebarOpen controlla la visibilità della sidebar SOLO su schermi piccoli (mobile)
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserData = async () => {
      const { data: sessionData, error: sessionError } = await supabase.auth.getSession();
      const userId = sessionData?.session?.user?.id;

      if (sessionError || !userId) {
        console.error('Nessuna sessione utente o errore:', sessionError?.message);
        navigate('/'); // Reindirizza al login se non autenticato
        return;
      }

      const { data: utente, error: userProfileError } = await supabase
        .from('utenti')
        .select('nome, cognome, ruolo')
        .eq('id', userId)
        .single();

      if (userProfileError || !utente) {
        console.error('Errore nel caricamento del profilo utente:', userProfileError?.message);
        navigate('/'); // Reindirizza se il profilo non è trovato
        return;
      }

      // ⭐ Controllo specifico del ruolo: solo 'broker' può accedere qui ⭐
      if (utente.ruolo !== 'broker') {
        console.warn(`Utente ${utente.nome} ${utente.cognome} con ruolo ${utente.ruolo} ha tentato di accedere a DashboardBroker.`);
        navigate('/'); // Reindirizza se non è broker
        return;
      }

      setUserData({ nome: utente.nome, cognome: utente.cognome, ruolo: utente.ruolo });
      setLoading(false); // Fine caricamento
    };

    fetchUserData();

    // Listener per i cambiamenti di autenticazione (per reindirizzare al logout)
    const { data: authListener } = supabase.auth.onAuthStateChange((_event, session) => {
      if (!session) {
        navigate('/');
      }
    });

    return () => {
      // ⭐ CORREZIONE QUI: Accedi a .data prima di .unsubscribe ⭐
      authListener?.data?.unsubscribe(); 
    };
  }, [navigate]);

  if (loading) {
    // Stile di caricamento semplice con Tailwind
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50 text-slate-800">
        <p className="text-xl font-semibold">Caricamento dashboard...</p>
      </div>
    );
  }

  // Se per qualche motivo il ruolo non è super_admin dopo il caricamento, non renderizzare
  if (userData.ruolo !== 'broker') {
    return null; // O reindirizza, a seconda della logica desiderata
  }

  return (
    // Contenitore principale della dashboard: full screen, layout flex
    // Su mobile: flex-col (elementi impilati verticalmente)
    // Su desktop (md:): flex-row (sidebar a sinistra, contenuto a destra)
    <div className="flex flex-col md:flex-row h-screen w-screen overflow-hidden bg-gray-50 text-slate-800 font-sans">
      {/* Sidebar - La sua visibilità su mobile è gestita dalla prop isOpen e dalle classi Tailwind interne */}
      <SidebarMenu
        nome={userData.nome}
        cognome={userData.cognome}
        isOpen={isSidebarOpen}
        closeSidebar={() => setSidebarOpen(false)}
        userRole={userData.ruolo} /* Passa il ruolo alla SidebarMenu */
      />

      {/* Overlay per la sidebar (visibile solo su mobile quando la sidebar è aperta) */}
      {isSidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40 md:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* ⭐ TopBarMobile - Ora renderizzato condizionalmente: solo se la sidebar NON è aperta ⭐ */}
      {!isSidebarOpen && (
        <TopBarMobile
          nome={userData.nome}
          cognome={userData.cognome}
          toggleSidebar={() => setSidebarOpen(true)} // Il bottone nella TopBarMobile aprirà la sidebar
          // La classe md:hidden è già gestita all'interno del componente TopBarMobile stesso
        />
      )}

      {/* Contenuto principale della dashboard */}
      {/* Su desktop, prende lo spazio rimanente (flex-1). */}
      {/* Su mobile, è a tutta larghezza. */}
      <div className={`flex-1 overflow-y-auto transition-all duration-300 ease-in-out`}>

        {/* Area del contenuto delle rotte annidate */}
        {/* ⭐ NUOVA CLASSE: pt-16 per creare spazio sotto la TopBarMobile quando è visibile. md:pt-8 per rimuoverlo su desktop. ⭐ */}
        <main className="p-4 md:p-8 pt-[84px] md:pt-8"> {/* Padding per il contenuto, responsivo */}
          <Outlet />
        </main>
      </div>
    </div>
  );
}
